










import { defineComponent } from '@vue/composition-api';
import AdvCommonContainer from '@/components/adv-components/adv-common-container';
import { leaveHomeWebview } from '@/shared/utils/goBack';
import { HOME_ADV_ID_MAP } from '@/pages/home/constant';

export default defineComponent({
  name: 'BackPopup',
  components: {
    AdvCommonContainer,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const gotoLeaveHomePage = () => {
      leaveHomeWebview();
    };

    return {
      gotoLeaveHomePage,
      HOME_ADV_ID_MAP,
    };
  },
});
